import * as React from 'react';

const Close = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M13.41 12L17.71 7.71C18.102 7.318 18.102 6.682 17.71 6.29C17.318 5.898 16.682 5.898 16.29 6.29L12 10.59L7.70999 6.29C7.31799 5.898 6.68199 5.898 6.28999 6.29C5.89799 6.682 5.89799 7.318 6.28999 7.71L10.59 12L6.28999 16.29C5.89799 16.679 5.89499 17.312 6.28399 17.704L6.28999 17.71C6.67899 18.102 7.31199 18.105 7.70399 17.716L7.70999 17.71L12 13.41L16.29 17.71C16.679 18.102 17.312 18.105 17.704 17.716L17.71 17.71C18.102 17.321 18.105 16.688 17.716 16.296L17.71 16.29L13.41 12Z" fill="currentColor"/>
  </svg>
);

export default Close;
